module.exports = __webpack_public_path__ + "assets/question-mark-circle-8bc9c145907e1f6ace30eeb29e4c097e.svg";